import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Container from 'react-bootstrap/Container'
import Col from 'react-bootstrap/Col'
import Image from '../components/image'
import Button from 'react-bootstrap/Button'
import ButtonToolbar from 'react-bootstrap/ButtonToolbar'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import Form from 'react-bootstrap/Form'
import Modals from "../components/Modals";


const BestelPage2 = () => {

return (
  <Layout>
    <SEO title="Bestel pagina2" />
    <h1>Bestellen</h1>
    <p>Op deze pagina kunt u uw bestelling doorgeven.</p>
    <Container>
    <Form name="contact2" method="POST" data-netlify="true">
      <input type="hidden" name="form-name" value="contact2" />
      <Form.Row>
      <Form.Group as={Col} controlId="formGridName">
          <Form.Label>Naam</Form.Label>
          <Form.Control required name="Naam" placeholder="" />
        </Form.Group>

        <Form.Group as={Col} controlId="formGridEmail">
          <Form.Label>Email</Form.Label>
          <Form.Control required name="Emailadres" type="email" placeholder="" />
        </Form.Group>
      
      </Form.Row>

      <Form.Group controlId="formGridMobile">
        <Form.Label>Mobiel nummer</Form.Label>
        <Form.Control required name="Mobiel-nummer" placeholder="" />
      </Form.Group>

      <Form.Group controlId="formGridAddress1">
        <Form.Label>Adres</Form.Label>
        <Form.Control required name="Adres" placeholder="" />
      </Form.Group>

      <Form.Row>

      <Form.Group as={Col} controlId="formGridZip">
          <Form.Label>Postcode</Form.Label>
          <Form.Control required name="Postcode" />
        </Form.Group>

        <Form.Group as={Col} controlId="formGridCity">
          <Form.Label>Woonplaats</Form.Label>
          <Form.Control required name="Woonplaats" />
        </Form.Group>
      </Form.Row>

      <h4>Modellen:</h4>

      <Form.Row>
      <Modals imageName="model1" description="jeans">
      <Image height="120px" width="120px" imageName="model1" />
      </Modals>
      <Form.Group as={Col}  controlId="formGridModel1">
        <Form.Label>Aantal jeans (&euro; 5)</Form.Label>
          <Form.Control type="number" name="Model1" min="0" max="50" step="1" placeholder="" />
        </Form.Group>

        <Form.Group as={Col} name="Model1Size" controlId="formGridModel1Size">
        <Form.Label>Maat jeans</Form.Label>
        <Form.Control name="Model1-maat" as="select" custom>
          <option>-</option>
          <option>S</option>
          <option>M</option>
          <option>L</option>
        </Form.Control>
      </Form.Group>
      </Form.Row>

      <Form.Row>
      <Modals imageName="model2" description="grijs ster">
      <Image height="120px" width="120px" imageName="model2" />
      </Modals>
      <Form.Group as={Col}  controlId="formGridModel2">
        <Form.Label>Aantal grijs ster (&euro; 5)</Form.Label>
          <Form.Control name="Model2" type="number" min="0" max="50" step="1" placeholder="" />
        </Form.Group>

        <Form.Group as={Col} controlId="formGridModel2Size">
        <Form.Label>Maat grijs ster</Form.Label>
        <Form.Control name="Model2-maat" as="select" custom>
          <option>-</option>
          <option>S</option>
          <option>M</option>
          <option>L</option>
        </Form.Control>
      </Form.Group>
      </Form.Row>

      <Form.Row>
      <Modals imageName="model3" description="blauw ster">
      <Image height="120px" width="120px" imageName="model3" />
      </Modals>
      <Form.Group as={Col}  controlId="formGridModel3">
        <Form.Label>Aantal blauw ster (&euro; 5)</Form.Label>
          <Form.Control name="Model3" type="number" min="0" max="50" step="1" placeholder="" />
        </Form.Group>

        <Form.Group as={Col} controlId="formGridModel3Size">
        <Form.Label>Maat blauw ster</Form.Label>
        <Form.Control name="Model3-maat" as="select" custom>
          <option>-</option>
          <option>S</option>
          <option>M</option>
          <option>L</option>
        </Form.Control>
      </Form.Group>
      </Form.Row>

      <Form.Row>
      <Modals imageName="model4" description="groen ster">
      <Image height="120px" width="120px" imageName="model4" />
      </Modals>
      <Form.Group as={Col}  controlId="formGridModel4">
        <Form.Label>Aantal groen ster (&euro; 5)</Form.Label>
          <Form.Control name="Model4" type="number" min="0" max="50" step="1" placeholder="" />
        </Form.Group>

        <Form.Group as={Col} controlId="formGridModel4Size">
        <Form.Label>Maat groen ster</Form.Label>
        <Form.Control name="Model4-maat" as="select" custom>
          <option>-</option>
          <option>S</option>
          <option>M</option>
          <option>L</option>
        </Form.Control>
      </Form.Group>
      </Form.Row>

      <Form.Row>
      <Modals imageName="model5" description="geel ster">
      <Image height="120px" width="120px" imageName="model5" />
      </Modals>
      <Form.Group as={Col}  controlId="formGridModel5">
        <Form.Label>Aantal geel ster (&euro; 5)</Form.Label>
          <Form.Control name="Model5" type="number" min="0" max="50" step="1" placeholder="" />
        </Form.Group>

        <Form.Group as={Col} controlId="formGridModel5Size">
        <Form.Label>Maat geel ster</Form.Label>
        <Form.Control name="Model5-maat" as="select" custom>
          <option>-</option>
          <option>S</option>
          <option>M</option>
          <option>L</option>
        </Form.Control>
      </Form.Group>
      </Form.Row>

      <Form.Row>
      <Modals imageName="model6" description="roze ster">
      <Image height="120px" width="120px" imageName="model6" />
      </Modals>
      <Form.Group as={Col}  controlId="formGridModel6">
        <Form.Label>Aantal roze ster (&euro; 5)</Form.Label>
          <Form.Control name="Model6" type="number" min="0" max="50" step="1" placeholder="" />
        </Form.Group>

        <Form.Group as={Col} controlId="formGridModel6Size">
        <Form.Label>Maat roze ster</Form.Label>
        <Form.Control name="Model6-maat" as="select" custom>
          <option>-</option>
          <option>S</option>
          <option>M</option>
          <option>L</option>
        </Form.Control>
      </Form.Group>
      </Form.Row>


      <Form.Row>
      <Modals imageName="model7" description="panter">
        <Image height="120px" width="120px" imageName="model7" />
      </Modals>
      <Form.Group as={Col}  controlId="formGridModel7">
        <Form.Label>Aantal panter (&euro; 5)</Form.Label>
          <Form.Control name="Model7" type="number" min="0" max="50" step="1" placeholder="" />
        </Form.Group>

        <Form.Group as={Col} controlId="formGridModel7Size">
        <Form.Label>Maat panter</Form.Label>
        <Form.Control name="Model7-maat" as="select" custom>
          <option>-</option>
          <option>S</option>
          <option>M</option>
          <option>L</option>
        </Form.Control>
        </Form.Group>
      </Form.Row>

      <Form.Row>
      <Modals imageName="model8" description="sparta">
        <Image height="120px" width="120px" imageName="model8" />
      </Modals>
      <Form.Group as={Col}  controlId="formGridModel8">
        <Form.Label>Aantal Sparta (&euro; 7)</Form.Label>
          <Form.Control name="Model8" type="number" min="0" max="50" step="1" placeholder="" />
        </Form.Group>

        <Form.Group as={Col} controlId="formGridModel8Size">
        <Form.Label>Maat Sparta</Form.Label>
        <Form.Control name="Model8-maat" as="select" custom>
          <option>-</option>
          <option>S</option>
          <option>M</option>
          <option>L</option>
        </Form.Control>
        </Form.Group>
      </Form.Row>

      <Form.Group controlId="formGridBezorgoptie">
          <Form.Label>Bezorg optie</Form.Label>
          <Form.Control name="Bezorgoptie" as="select" custom>
            <option>Verzenden</option>
            <option>Ophalen</option>
          </Form.Control>
      </Form.Group>

      <br />

      <ButtonToolbar aria-label="Toolbar with button groups" className="justify-content-around">
        <ButtonGroup aria-label="B1" size="lg">
          <Button variant="success" type="submit">Bestellen!</Button>
        </ButtonGroup> 
        <ButtonGroup aria-label="B2" size="sm">
          <Button variant="danger" type="reset">Reset</Button>
        </ButtonGroup> 
      </ButtonToolbar>

      </Form>
        </Container>

        <Link to="/">Terug naar de hoofdpagina</Link>
    
    </Layout>
);
}



export default BestelPage2
